export const CREDITS_PER = {
  EMAIL: 20,
  // PHONE: 1,
};

export const PLANS = {
  FREE: {
    price: 0,
    benefits: [
      "AI PDF Processing + Web Scraping",
      "Experiment-ready Credit Amounts",
      "Private + Public sharing options",
    ],
    description: "Experiment with Chatsheet for free. Build scalable AI workflows in seconds.",
  },
  PLUS: {
    benefits: ["All AI Features", "Production-ready Credit Amounts", "Private + Public sharing options"],
    description: "Optimized for balanced accuracy and cost. Great for sales pros and marketers.",
    subtiers: [
      {
        label: "plus_tier_1_monthly",
        price: 19,
      },
      {
        label: "plus_tier_2_monthly",
        price: 39,
      },
      {
        label: "plus_tier_3_monthly",
        price: 79,
      },
    ],
  },
  TEAM: {
    benefits: ["All AI Features", "Volume Credits Savings", "Team-based Sharing (Coming Soon)"],
    description: "Built for teams. Seamless collaboration and volume-based savings.",
    subtiers: [
      {
        label: "team_tier_1_monthly",
        price: 145,
      },
      {
        label: "team_tier_2_monthly",
        price: 218,
      },
      {
        label: "team_tier_3_monthly",
        price: 290,
      },
      {
        label: "team_tier_4_monthly",
        price: 435,
      },
      {
        label: "team_tier_5_monthly",
        price: 580,
      },
      {
        label: "team_tier_6_monthly",
        price: 725,
      },
      {
        label: "team_tier_7_monthly",
        price: 870,
      },
      {
        label: "team_tier_8_monthly",
        price: 1015,
      },
      {
        label: "team_tier_9_monthly",
        price: 1160,
      },
      {
        label: "team_tier_10_monthly",
        price: 1305,
      },
    ],
  },
  // PRO: {
  // 	benefits: [
  // 		"Unlimited Basic Searches",
  // 		"Unlimited Basic Exports",
  // 		"Unlimited Pro Searches",
  // 	],
  // 	description: "Built for professionals that want maximum accuracy. Great for recruiters and investors.",
  // 	subtiers: [
  // 		{
  // 			label: "pro_tier_1_monthly",
  //       price: 199,
  // 		},
  // 		{
  // 			label: "pro_tier_1_annual",
  // 			price: 159
  // 		},
  // 		{
  // 			label: "pro_tier_2_monthly",
  // 			price: 299,
  // 		},
  // 		{
  // 			label: "pro_tier_2_annual",
  // 			price: 239,
  // 		},
  // 		{
  // 			label: "pro_tier_3_monthly",
  // 			price: 399,
  // 		},
  // 		{
  // 			label: "pro_tier_3_annual",
  // 			price: 319,
  // 		}
  // 	]
  // }
};
